module.exports = __webpack_public_path__ + "img/kongqiye.cda2b484.png";